require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-art-of-iteration-how-we-shape-our-curriculum-for-the-needs-of-the-industry.json") })
        }
      }, "path---blog-the-art-of-iteration-how-we-shape-our-curriculum-for-the-needs-of-the-industry");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-art-of-iteration-how-we-shape-our-curriculum-for-the-needs-of-the-industry!./.cache/json/blog-the-art-of-iteration-how-we-shape-our-curriculum-for-the-needs-of-the-industry.json
// module id = 1062
// module chunks = 231608221292675